import React from "react";

const Recommendation = () => {
  return (
    <div className="recommend">
      <div className="number">
        <span>#1</span>
      </div>
      <div className="recommend-description">
        <div className="title">100% Federally Legal & Natural CBD Brand</div>
        <div className="description">For Enthusiasts, by Connoisseurs.</div>
      </div>
    </div>
  );
};

export default Recommendation;
